import type { ComponentPropsWithoutRef } from 'react';

import { forwardRef } from 'react';
import { Box as ThemeBox } from 'theme-ui';

import { getClickableStyle } from '../../utils/style';

type ThemeBoxProps = ComponentPropsWithoutRef<typeof ThemeBox>;

export type BoxProps = ThemeBoxProps;

const Box = forwardRef<HTMLElement, BoxProps>(function Box(props, ref) {
  const { disabled, sx = {}, onClick, ...rest } = props;
  const clickableStyle = getClickableStyle(props);
  return (
    <ThemeBox
      disabled={disabled}
      ref={ref}
      sx={{ ...clickableStyle, ...sx }}
      onClick={!disabled && onClick ? onClick : undefined}
      {...rest}
    />
  );
});

export default Box;
